import { GivingPage } from "@/features/giving/GivingPage";
import { YouthChurchPage } from "@/pages/YouthChurchPage";
import {
  Navigate,
  type RouteObject,
} from "react-router-dom";

import { ProtectedRoute } from "@/app/ProtectedRoute";
import { AppLayout } from "@/components/layout/AppLayout";

import { ForgotPasswordPage } from "@/features/auth/pages/ForgotPasswordPage";
import { LoginPage } from "@/features/auth/pages/LoginPage";
import { ResetPasswordPage } from "@/features/auth/pages/ResetPasswordPage";
import { InvitationPage } from "@/features/onboarding/pages/InvitationPage";

import { AttendancePage } from "@/pages/AttendancePage";
import { AttendanceReportPage } from "@/pages/AttendanceReportPage";
import { CareQueuePage } from "@/pages/CareQueuePage";
import { DashboardPage } from "@/pages/DashboardPage";
import { DataImportPage } from "@/pages/DataImportPage";
import { HouseholdProfilePage } from "@/pages/HouseholdProfilePage";
import { HouseholdsPage } from "@/pages/HouseholdsPage";
import { IntelligencePage } from "@/pages/IntelligencePage";
import { MemberProfilePage } from "@/pages/MemberProfilePage";
import { MembersPage } from "@/pages/MembersPage";
import { ReportsPage } from "@/pages/ReportsPage";
import { ServiceAttendancePage } from "@/pages/ServiceAttendancePage";
import { ServiceProfilePage } from "@/pages/ServiceProfilePage";
import { ServicesPage } from "@/pages/ServicesPage";
import { SystemHealthPage } from "@/pages/SystemHealthPage";
import { AuthorizationAdministrationPage } from "@/pages/administration/AuthorizationAdministrationPage";

export const churchRoutes: RouteObject[] = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/invite/:token",
    element: <InvitationPage />,
  },

  // Temporary compatibility redirects.
  {
    path: "/app/login",
    element: <Navigate to="/login" replace />,
  },
  {
    path: "/app/forgot-password",
    element: (
      <Navigate
        to="/forgot-password"
        replace
      />
    ),
  },
  {
    path: "/app/reset-password",
    element: (
      <Navigate
        to="/reset-password"
        replace
      />
    ),
  },
  {
    path: "/app",
    element: <Navigate to="/" replace />,
  },
  {
    path: "/app/members",
    element: <Navigate to="/members" replace />,
  },
  {
    path: "/app/members/:memberId",
    element: <Navigate to="/members" replace />,
  },
  {
    path: "/app/households",
    element: <Navigate to="/households" replace />,
  },
  {
    path: "/app/attendance",
    element: <Navigate to="/attendance" replace />,
  },
  {
    path: "/app/services",
    element: <Navigate to="/services" replace />,
  },
  {
    path: "/app/care-queue",
    element: <Navigate to="/care-queue" replace />,
  },
  {
    path: "/app/reports",
    element: <Navigate to="/reports" replace />,
  },
  {
    path: "/app/intelligence",
    element: <Navigate to="/intelligence" replace />,
  },
  {
    path: "/app/settings/data-import",
    element: (
      <Navigate
        to="/settings/data-import"
        replace
      />
    ),
  },
  {
    path: "/app/settings/system-health",
    element: (
      <Navigate
        to="/settings/system-health"
        replace
      />
    ),
  },

  {
    element: <ProtectedRoute />,
    children: [
      {
        path: "/",
        element: <AppLayout />,
        children: [
          {
            index: true,
            element: <DashboardPage />,
          },
          {
            path: "members",
            element: <MembersPage />,
          },
          {
            path: "members/:memberId",
            element: <MemberProfilePage />,
          },
          {
            path: "households",
            element: <HouseholdsPage />,
          },
          {
            path: "households/:householdId",
            element: <HouseholdProfilePage />,
          },
          {
            path: "attendance",
            element: <AttendancePage />,
          },
          {
            path: "attendance/:serviceId",
            element: <ServiceAttendancePage />,
          },
          { path: "youth", element: <YouthChurchPage /> },
          {
            path: "services",
            element: <ServicesPage />,
          },
          {
            path: "services/:serviceId",
            element: <ServiceProfilePage />,
          },
          {
            path: "care-queue",
            element: <CareQueuePage />,
          },
          {
            path: "reports",
            element: <ReportsPage />,
          },
          {
            path: "reports/attendance",
            element: <AttendanceReportPage />,
          },
          {
            path: "intelligence",
            element: <IntelligencePage />,
          },
          {
            path: "treasure",
            element: <GivingPage view="overview" />,
          },
          {
            path: "treasure/contributions",
            element: <GivingPage view="contributions" />,
          },
          {
            path: "treasure/funds",
            element: <GivingPage view="funds" />,
          },
          {
            path: "treasure/imports",
            element: <GivingPage view="imports" />,
          },
          {
            path: "treasure/reports",
            element: <GivingPage view="reports" />,
          },
          {
            path: "treasure/settings",
            element: <GivingPage view="settings" />,
          },
          {
            path: "settings/giving",
            element: <Navigate to="/treasure/imports" replace />,
          },
          {
            path: "settings/data-import",
            element: <DataImportPage />,
          },
          {
            path: "settings/system-health",
            element: <SystemHealthPage />,
          },
          { path: "settings/administration", element: <Navigate to="/settings/administration/ministries" replace /> },
          { path: "settings/administration/ministries", element: <AuthorizationAdministrationPage section="ministries" /> },
          { path: "settings/administration/roles", element: <AuthorizationAdministrationPage section="roles" /> },
          { path: "settings/administration/assignments", element: <AuthorizationAdministrationPage section="assignments" /> },
        ],
      },
    ],
  },
];
